/** Api methods */
import * as AdminAnalyticsApi from "./api/adminAnalytics";
import * as AnalyticsApi from "./api/analytics";
import * as ApiKeyApi from "./api/apiKey";
import * as ApplicationApi from "./api/application";
import * as ArtifactApi from "./api/artifact";
import * as AuthApi from "./api/auth";
import * as BlockApi from "./api/block";
import * as BlockMessageApi from "./api/blockMessages";
import * as BrainApi from "./api/brain";
import * as ChatApi from "./api/chat";
import * as ChatbotApi from "./api/chatbot";
import * as CompaniesApi from "./api/companies";
import * as ContentApi from "./api/content";
import * as DocumentTemplatesApi from "./api/documentTemplates";
import * as HealthApi from "./api/health";
import * as IntegrationApi from "./api/integration";
import * as NotificationApi from "./api/notifications";
import * as PermissionApi from "./api/permission";
import * as PromptApi from "./api/prompt";
import * as PromptCategoryApi from "./api/promptCategory";
import * as RatingApi from "./api/rating";
import * as SessionApi from "./api/sessions";
import * as StepApi from "./api/step";
import * as TeamApi from "./api/team";
import * as TeamsApplicationApi from "./api/teamsApplications";
import * as TeamsBrainApi from "./api/teamsBrain";
import * as UserApi from "./api/user";
import * as UserApplicationApi from "./api/userapplication";
import * as UserBrainApi from "./api/userbrain";
import * as UserTeamApi from "./api/userTeam";
/** Content Api methods */
import * as UploadContentApi from "./content-api/content";
import * as DownloadApi from "./content-api/download";

export const ApiCaller = {
	...AdminAnalyticsApi,
	...AnalyticsApi,
	...ApiKeyApi,
	...ArtifactApi,
	...AuthApi,
	...BrainApi,
	...ChatApi,
	...ChatbotApi,
	...CompaniesApi,
	...ContentApi,
	...DocumentTemplatesApi,
	...HealthApi,
	...IntegrationApi,
	...PermissionApi,
	...PromptApi,
	...PromptCategoryApi,
	...UserApi,
	...ApplicationApi,
	...NotificationApi,
	...BlockApi,
	...BlockMessageApi,
	...UserBrainApi,
	...TeamApi,
	...TeamsBrainApi,
	...TeamsApplicationApi,
	...RatingApi,
	...UserApplicationApi,
	...SessionApi,
	...StepApi,
	...UserTeamApi,
};

export const ContentApiCaller = {
	...UploadContentApi,
	...DownloadApi,
};

export type { AuthMethod, IdentifyResponse } from "./api/auth";
export { DRAG_AND_DROP_BRAIN_NAME } from "./api/brain";
export {
	setChatbotApiAccessToken,
	setupChatbotApiInterceptors,
} from "./chatbot-api/axios-instance";
export type { ChatsInfiniteData } from "./api/chat";
export type { MySessionsInfiniteData } from "./api/sessions";
export { default as env } from "./environments";
export * from "./query-client/infiniteData";
export * from "./generated/chatbot-api";
export * from "./query-client/queryClient";
export * from "./query-client/queryKeys";
export * from "./cache/artifactCache";
